import React from "react";
import Select from "@/components/UIKits/Select";
import { PLATFORMS } from "@/utils/constants";

const { Option } = Select;

const Element = ({ onChange, ...params }) => {
  return (
    <Select showSearch={true} onChange={onChange} {...params}>
      {Object.values(PLATFORMS).map((platform) => (
        <Option key={platform.value} value={platform.value}>
          {platform.label}
        </Option>
      ))}
    </Select>
  );
};

export default Element;
